/* istanbul ignore file */

import { Container, ServiceIdentifier } from 'inversify';

export const container = new Container({
  defaultScope: 'Singleton',
  autobind: true,
});

export type Inject = <T>(identifier: ServiceIdentifier<T>) => T;

export function inject<T>(
  identifier: ServiceIdentifier<T>,
  injectContainer = container,
): T {
  return injectContainer.get<T>(identifier);
}
